/**
 * Filler-word detection. V1 only *marks* fillers (and can hide them from
 * captions) - it never edits the source audio/video.
 */
const FILLERS = new Set([
    'um',
    'uh',
    'uhh',
    'umm',
    'er',
    'ah',
    'hmm',
    'like',
    'basically',
    'actually',
    'literally',
    'yeah',
]);
/** Words that are only fillers in isolation (e.g. "like" as a verb is fine).
 *  We keep V1 simple: mark by token match; the user reviews before hiding. */
export function detectFillers(words) {
    return words.map((w) => {
        const clean = w.text.toLowerCase().replace(/[^\p{L}]/gu, '');
        return FILLERS.has(clean) ? { ...w, isFiller: true } : w;
    });
}
export function hideFillers(words) {
    return words.map((w) => (w.isFiller ? { ...w, hidden: true } : w));
}
export function isFillerToken(text) {
    return FILLERS.has(text.toLowerCase().replace(/[^\p{L}]/gu, ''));
}
//# sourceMappingURL=fillers.js.map